import { Avatar, Box, Container, Skeleton, Stack } from '@mui/material';
import React from 'react';

import senaface from '../../../assets/paige.jpeg';
import { SENDER_TYPES } from '../slice/constants';
// import FixedFooter from './FixedFooter';

const SkeletonItem = ({ sender }: { sender: string }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: sender === SENDER_TYPES.USER ? 'flex-end' : 'flex-start',
        alignItems: 'center',
        gap: 2,
      }}
    >
      {sender === SENDER_TYPES.ASSISTANT && <Avatar src={senaface} alt="Sena" sx={{ width: 32, height: 32 }} />}

      <Skeleton variant="text" width="100%" height={40} sx={{ maxWidth: '30%' }} />

      {sender === SENDER_TYPES.USER && <Avatar sx={{ width: 32, height: 32 }}>U</Avatar>}
    </Box>
  );
};

export default function ChatSessionLoadingSkeleton() {
  return (
    <Box
      sx={{
        p: '2rem 0rem',
        height: 'calc(100vh - 120px)',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
      }}
    >
      <Container maxWidth="lg">
        <Stack spacing={2}>
          <SkeletonItem sender={SENDER_TYPES.USER} />
          <SkeletonItem sender={SENDER_TYPES.ASSISTANT} />
          <SkeletonItem sender={SENDER_TYPES.USER} />
          <SkeletonItem sender={SENDER_TYPES.ASSISTANT} />
          <SkeletonItem sender={SENDER_TYPES.USER} />
          <SkeletonItem sender={SENDER_TYPES.ASSISTANT} />
        </Stack>
      </Container>
      {/* <FixedFooter disabled={true} /> */}
    </Box>
  );
}
